import type { MembershipSummary } from "@/data/workspaces";

const LAST_WORKSPACE_SLUG_KEY = "parable:last-workspace-slug";

export function chooseRootWorkspaceSlug(
  memberships: MembershipSummary[],
  storedSlug: string | null,
): string | null {
  if (storedSlug) {
    const storedMembership = memberships.find(
      (membership) => membership.workspace.slug === storedSlug,
    );
    if (storedMembership) return storedMembership.workspace.slug;
  }
  return memberships[0]?.workspace.slug ?? null;
}

export function readLastWorkspaceSlug(): string | null {
  try {
    const value = window.localStorage.getItem(LAST_WORKSPACE_SLUG_KEY);
    return value?.trim() || null;
  } catch {
    return null;
  }
}

export function writeLastWorkspaceSlug(slug: string): void {
  try {
    window.localStorage.setItem(LAST_WORKSPACE_SLUG_KEY, slug);
  } catch {
    // Browsers can deny storage in privacy modes. Navigation should still work.
  }
}
